module.exports = __webpack_public_path__ + "img/fssbqzx_position_img.0b46d6e9.png";